<template lang="" enter-class="common-for-all">
  <div>
    <div v-if="view =='vehicleDetails'" class="select-RTO">

      <div class="commoncard">
        <div class="d-flex justify-content-between gap-2 mb-2 align-items-center">
          <!-- <div class="iconback"  >
          <img src="/images/backarrow.svg" width="15px" class="selectrtosvg" />
        </div> -->
          <div class="searchinput w-100">
            <input class="form-control mr-sm-2" type="search" style="padding:10px; text-transform:uppercase" :placeholder="motorProductType ==='4W-Pvt' ? carplaceholder: bikeplaceholder " aria-label="Search" v-model="searchData" ref="searchInput" @input="filterData()" @focus="isUserEditing = true" />
            <img src="../../assets/images/search.svg" v-if="!searchData" />
            <span v-if="searchData" @click="clearSearchTerm()" tabindex='10' class="cross_icon-search">&times;</span>
          </div>
          <!-- <div class="iconback">
          <img src="/images/forwardarrow.svg"  width="15px" class="selectrtosvg" />
        </div> -->

        </div>

        <small id="emailHelp" class="form-text text-muted d-flex  align-items-center"> <img src="../../assets/images/info.svg" class="backarrow cursor-pointer" />
          <!-- <label>Eg. {{motorProductType ==='4W-Pvt' ? carexample: bikeexample }}</label> -->
          <label>Eg. {{ this.showExample() }}</label>
        </small>
        <p class="mt-3 error-text" v-if="this.noSearchMatch && filteredResultData.length==0 && this.searchData!=''">No Record Found</p>
        <div v-if="filteredResultData.length > 0"></div>
        <div v-if="!(this.noSearchMatch && filteredResultData.length==0 && this.searchData!='')">
          <div v-if="filteredResultData.length > 0">
            <div>
              <div v-for="(item, index) in filteredResultData" :key="index" class="selectState d-flex justify-content-between" :style="{'background-color': (typeof(item)=='String' && item === selectedItemvalue || deepEqual(JSON.parse(JSON.stringify(item)), JSON.parse(JSON.stringify(selectedItemvalue)))) ? '#3B39D9' : $store.state.theme == 'light' ? '' : ''}" :class="{
              'selected_value': typeof item === 'string' && item === selectedItemvalue || deepEqual(JSON.parse(JSON.stringify(item)), JSON.parse(JSON.stringify(selectedItemvalue)))}" @click="getNewData(item)">
                <p v-if="displayStepData=='state'" class="mb-0">{{ (item).toUpperCase()}}</p>
                <p v-if="displayStepData=='city'" class="mb-0">{{ (item).toUpperCase() }}</p>
                <p v-if="displayStepData=='rtoCode'" class="mb-0">{{ (item).toUpperCase() }}({{ this.sessionUserData ? this.sessionUserData.city : '' }})</p>
                <p v-if="displayStepData=='carMake'" class="mb-0">{{(item.makeDescription).toUpperCase() }}</p>
                <p v-if="displayStepData=='model'" class="mb-0">{{(item.modelDesc).toUpperCase() }}</p>
                <p v-if="displayStepData=='variant'" class="mb-0">{{(item.variantDesc).toUpperCase() }}</p>
                <p v-if="displayStepData=='fuelType'" class="mb-0">{{(item).toUpperCase() }}</p>
                <div>

                  <img src="../../assets/images/rightarrow.svg" class="commonicon" />
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div v-for="(item, index) in displayedData" :key="index">
              <div class="selectState d-flex justify-content-between" :class="{'highlightColor': (typeof(item)=='String' && item === selectedItemvalue || deepEqual(JSON.parse(JSON.stringify(item)), JSON.parse(JSON.stringify(selectedItemvalue))))}" @click="getNewData(item)">
                <p v-if="displayStepData=='state'" class="mb-0">{{ (item).toUpperCase() }}</p>
                <p v-if="displayStepData=='city'" class="mb-0">{{ (item).toUpperCase()}}</p>
                <p v-if="displayStepData=='rtoCode'" class="mb-0">{{ (item).toUpperCase() }} ({{ this.sessionUserData ? this.sessionUserData.city?.toUpperCase() : '' }})</p>
                <p v-if="displayStepData=='carMake'" class="mb-0">{{(item.makeDescription).toUpperCase() }}</p>
                <p v-if="displayStepData=='model'" class="mb-0">{{(item.modelDesc).toUpperCase() }}</p>
                <p v-if="displayStepData=='variant'" class="mb-0">{{(item.variantDesc).toUpperCase()}}</p>
                <p v-if="displayStepData=='fuelType'" class="mb-0">{{(item).toUpperCase() }}</p>

                <div>
                  <img src="../../assets/images/rightarrow.svg" class="commonicon" />
                </div>
              </div>

            </div>
          </div>
        </div>

        <div v-if="!filteredResultData.length>0 && displayedData.length>9 && !(this.noSearchMatch && filteredResultData.length==0 && this.searchData!='')">
          <div v-if="!showAllItems">
            <button @click="showAllItems = !showAllItems" class="btn btn-link nextpagerout">View All</button>
          </div>
          <div v-if="showAllItems">
            <button @click="showAllItems = !showAllItems" class="btn btn-link nextpagerout">Show Less</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Showing Additional Details Page -->

    <div v-if="view=='additonalDetails'">
      <div class="additional-Details">
        <div class="commoncard">
          <div class="d-flex justify-content-between gap-2 mb-3 align-items-center">
            <!-- <div class="iconback"  >
          <img src="/images/backarrow.svg" width="15px" class="selectrtosvg" />
        </div> -->
            <p class="mb-0 w-100">
              Few more <b>additional</b> details about your {{this.motorProductType ==='4W-Pvt' ? "Car": "Bike" }}
            </p>
            <!-- <div class="iconback">
          <img src="/images/forwardarrow.svg"  width="15px" class="selectrtosvg" />
        </div> -->

          </div>

          <div class="manage-selects mb-3">
            <div class="position-relative">

              <label class="headinglabel">Registration Date </label>
              <span class="data-placeholder" @click="openDatePicker('dob')" v-if="isMobileView() && !selectedDate">dd-mm-yyyy</span>
              <div class="position-relative">
                <DateField id="selectedDate" name="selectedDate" :max="maxDate" :min="minDate" v-model="selectedDate" @blurInput="handleDateChange" />
              </div>
            </div>
            <div>
              <label class="headinglabel">Manufacturing Year </label>
              <div class="position-relative ">
                <select class="form-select" v-model="selectedYear" aria-label="Default select example" :disabled="!selectedDate">
                  <option selected disabled value="0">Mfg Year</option>
                  <option v-for="year in yearOptions" :key="year" :value="year">{{ year }}</option>

                </select>
                <img src="/images/downarrow.svg" class="downarrowimage">
              </div>

            </div>
          </div>
          <p style="color:red;font-size:12px">
            {{dateError}}
          </p>

          <button class="btn commonButton " @click="getNewData('',selectedDate,selectedYear)" :disabled="!selectedDate">Proceed</button>
        </div>
      </div>
    </div>

    <!-- Showing Claim  -->
    <div v-if="view=='claim' && quoteCategory=='Roll-Over'">
      <div class="view-Claim">
        <div class="commoncard">
          <!-- <div class="d-flex justify-content-between gap-2  mb-3 align-items-center"  >
       
        <p class="mb-0 w-100" >Previous Policy Details <img src="../../assets/images/info.svg" class="commonicon"     /></p>
      
      
      </div> -->
        <div>
          <p class="mb-0">Previous Policy Expired for more than 90 days?</p>
          <div class="prev_policy_exp d-flex align-items-center mt-1 mb-1 pb-2">
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  id="prev_policy_exp_yes"
                  name="ownership_transfer"
                  v-model="previousPolicyExpired"
                  value="true"
                  @change="previousPolicyExpiredHandler()"
                >
                <label class="form-check-label mt-1" for="prev_policy_exp_yes">YES</label>
              </div>

              <div class="form-check form-check-inline mb-0">
                <input
                  class="form-check-input"
                  type="radio"
                  id="prev_policy_exp_no"
                  name="ownership_transfer"
                  v-model="previousPolicyExpired"
                  value="false"
                  @change="previousPolicyExpiredHandler()"
                >
                <label class="form-check-label mt-1" for="prev_policy_exp_no">NO</label>
              </div>
            </div>
        </div>

          <form v-if="previousPolicyExpired == 'false'">
            <label class="headinglabel">Previous Policy Type</label>
            <div class="position-relative">
              <select class="form-select mb-3" v-model="policyInfo.prevPolicyType.input" aria-label="Default select example" @change="prePolicyTypeHandler($event)">
                <option disabled value="">Previous Policy Type</option>
                <option v-for="(item, index) in previousPolicyTypes" :key="index" :value="item.NAME">{{ item.NAME?.toUpperCase() }}</option>
              </select>
              <img src="/images/downarrow.svg" class="downarrowimage">
            </div>

            <div v-if="showOdSection" class="position-relative">
              <label class="headinglabel"  v-if="!showPreviousExpiry && !isComprehensivePolicy()">Own Damage Expiry Date</label>
              <label class="headinglabel" v-if="showPreviousExpiry || isComprehensivePolicy()">Previous Policy Expiry Date</label>
              <div class="position-relative">
                <DateField id="odDate" name="odDate" :max="maxOdTpDate()" :min="minOdDate()" v-model="odDate" @onInput="validateOdDate" @blurInput="handleNcb"  />
              </div>
              <p style="color:red;font-size:12px">{{oddateError}}</p>
            </div>

            <label class="headinglabel">Previous Insurer Name</label>
            <div class="position-relative">
              <select class="form-select mb-3" v-model="policyInfo.prevInsurerName.input" aria-label="Default select example">
                <option disabled value="">Previous Insurer Name</option>
                <option v-for="(item, index) in previousInsurerName" :key="index" :value="item.manufacturer_name">{{ item.manufacturer_name }}</option>
              </select>
              <img src="/images/downarrow.svg" class="downarrowimage">
            </div>

            <div v-if="showTpSection && !isComprehensivePolicy()" class="position-relative">
              <label class="headinglabel">Third Party Expiry Date</label>
              <div class="position-relative">
                <DateField id="tpDate" name="tpDate" :max="setMaxTpExpiry()" :min="minOdDate()" v-model="tpDate" @blurInput="limitYear" />
              </div>
              <p style="color:red;font-size:12px">{{tpDateError}}</p>
            </div>

            <template v-if="showTpSection && !isComprehensivePolicy()">
              <label class="headinglabel">TP Insurer Name</label>
              <div class="position-relative">
                <select class="form-select mb-3" v-model="policyInfo.tpInsurerName.input" aria-label="Default select example">
                  <option disabled value="">TP Insurer Name</option>
                  <option v-for="(item, index) in previousInsurerName" :key="index" :value="item.manufacturer_name">{{ item.manufacturer_name }}</option>
                </select>
                <img src="/images/downarrow.svg" class="downarrowimage">
              </div>
            </template>

            <div v-if="policyInfo.ncb.visibility">
              <hr />
              <p class="mb-1">Confirm No Claim Bonus (NCB)<img src="../../assets/images/info.svg" class="commonicon" /></p>
              <p class="subheading">Did you make a claim in your existing policy?</p>
              <div class="form-check form-switch d-flex gap-2 align-item-center">
                <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckChecked" v-model="isChecked" @change="toggleFunction()" />
                <label class="form-check-label headinglabel" for="flexSwitchCheckChecked" style="margin-top:0.5rem">{{ isChecked ? 'Yes' : 'No' }}</label>
              </div>
              <div class=" position-relative">
                <div v-if="!isChecked">
                  <select class="form-select mt-3" v-model="applicablePercentage" aria-label="Default select example" v-if="percentOptions" @change="ncbPersentHandler($event)">
                    <option disabled value="">Select NCB Percentage</option>
                    <option v-for="(item, index) in percentOptions" :key="index" :value="item">{{ item }}</option>
                  </select>
                  <img src="/images/downarrow.svg" class="downarrowimage">
                </div>
              </div>
              <br />
              <div v-if="!isChecked && this.applicablePercentage !=''" class="rounddiv mb-2">
                <p>{{this.applicablePercentage}} NCB in previous year</p>
              </div>
              <div v-if="isChecked" class="rounddiv mb-2">
                <p class="text-align-left">NCB is not applicable</p>
              </div>
              <!-- <router-link  :to="odDate && tpDate ? '/policy-quote' : ''"> -->
              <p style="font-size:12px" v-if="this.quoteCategory=='Roll-Over'">Entering incorrect value of NCB percentage and Claim in previous policy can lead to rejection of claim in future.</p>
            </div>
            <button class="btn commonButton " @click="addOdTpDate($event)" :disabled="!odDate || (!isComprehensivePolicy() && !tpDate) || (policyInfo.ncb.visibility && !isChecked && this.applicablePercentage =='' ) || tpDateError != '' || oddateError!='' || !this.policyInfo.prevInsurerName.input || (policyInfo.tpInsurerName.visibility && !policyInfo.tpInsurerName.input) || !policyInfo.prevPolicyType?.input" v-if="!showPreviousExpiry">View Quotes</button>

            <!-- </router-link> -->
            <!-- <router-link  :to="odDate ? '/policy-quote' : ''"> -->
            <button class="btn commonButton " @click="addOdTpDate($event)" :disabled="!odDate || (policyInfo.ncb.visibility && !isChecked && this.applicablePercentage =='' ) || tpDateError !='' || oddateError!='' || !this.policyInfo.prevInsurerName.input || (policyInfo.tpInsurerName.visibility && !policyInfo.tpInsurerName.input) || !policyInfo.prevPolicyType?.input" v-if="showPreviousExpiry">View Quotes</button>
            <!-- </router-link> -->
          </form>
          <button class="btn commonButton" @click="addOdTpDate($event)" v-if="previousPolicyExpired == 'true'">View Quotes</button>
        </div>
      </div>
    </div>
    <!-- <div v-else-if="view=='claim' && quoteCategory=='New'">
      <div class="view-Claim commoncard">
        <input type="text" class="form-control mt-3" id="mob-number" v-model.trim="newBikeUser.mobile" placeholder="Mobile Number" @keypress="isNumber($event)" maxlength="10" @input="getFieldValidation('mobile',$event)" />
        <p class="error-text mt-2" v-if="error.mobile" style="color: red;">{{ error.mobile }}</p>
        <input type="text" class="form-control mt-3" id="email" v-model.trim="newBikeUser.email" placeholder="Email" @input="getFieldValidation('email',$event)" />
        <p class="error-text" v-if="error.email" style="color: red;">{{ error.email }}</p>
        <button class="btn commonButton mt-3" :class="{disabledButton: checkformData()}" :disabled="incorrectData" @click="ViewQuoteNewVehicle($event)">View Quotes</button>
      </div>
    </div> -->
  </div>
<div v-if="view=='claim' && quoteCategory=='New'">
  <div class="view-Claim commoncard">
    <input
      type="text"
      class="form-control mt-3"
      id="mob-number"
      v-model.trim="newBikeUser.mobile"
      placeholder="Mobile Number"
      @keypress="isNumber($event)"
      @paste="onPaste($event)"
      maxlength="10"
      @input="getFieldValidation('mobile',$event)"
    
    />
    <p class="error-text mt-2" v-if="error.mobile" style="color: red;" >{{ error.mobile }}</p>
    <input
      type="text"
      class="form-control mt-3"
      id="email"
      v-model.trim="newBikeUser.email"
      placeholder="Email"
      @input="getFieldValidation('email',$event)"
    />
    <p class="error-text" v-if="error.email" style="color: red;">{{ error.email }}</p>
    <button class="btn commonButton mt-3" :class="{disabledButton: checkformData()}" :disabled="incorrectData" @click="ViewQuoteNewVehicle($event)">View Quotes</button>
  </div>
</div>
</template>
<script>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import moment from 'moment';

export default {
  name: "VehicleDetails",
  props: {
    carplaceholder: {
      type: String,
      required: true,
    },
    bikeplaceholder: {
      type: String,
      required: true,
    },
    carexample: {
      type: String,
      required: true,
    },
    bikeexample: {
      type: String,
      required: true,
    },
    view: {
      type: String,
      required: true,
    },
    data: {
      type: Array,
      default: () => [],
    },
    displayStepData: {
      type: String,
      required: false,
    },
    showOdSection: {
      type: Boolean,
      required: false,
    },
    showTpSection: {
      type: Boolean,
      required: false,
    },
    showPreviousExpiry: {
      type: Boolean,
      required: false,
    },
    percentOptions:{
      type: Object,
      required: false,
    },
    selectedItemvalue:{
      type:String
    },
    sessionUserData:{
      type:Object
    }
  },
  setup() {
    const searchInput = ref(null);

    const focusSearchInput = () => {
      if (searchInput.value) {
        searchInput.value.focus();
      }
    };

    function focusTheInput(){
       searchInput.value.focus();
    }

    const handleKeyPress = () => {
      focusSearchInput();
    };

    onMounted(() => {
      focusSearchInput();
      window.addEventListener('keypress', handleKeyPress);
    });

    onBeforeUnmount(() => {
      window.removeEventListener('keypress', handleKeyPress);
    });

    return {
      searchInput,
      focusTheInput
    };
  },
  data() {
    return {
      applicablePercentage: sessionStorage.getItem("userData") ? JSON.parse(sessionStorage.getItem("userData"))?.setNCBbasedOnRegDate : "",
      isChecked: false, 
      displayNewStepData: null,
      userData: {},
      searchData: "",
      resultData: [],
      showAllItems: false,
      newItem:[],
      filteredResultData:[],
      selectedDate: '', 
      selectedYear: 0, 
      yearOptions: [],
      motorProductType:'',
      odDate:'',
      tpDate:'',
      quoteCategory:'',
      dateError:"",
      oddateError:"",
      newBikeUser:{
        mobile:'',
        email: '',
      },
      error:[],
      incorrectData: true,
      noSearchMatch: false,
      isBHSeries: false,
      isUserEditing: false,
      bhMinDate: "",
      tpDateError: "",
      registrationDate: "",
      policyInfo: {
        prevPolicyType: {
          input: "",
          visibility: true
        },
        prevInsurerName: {
          input: "",
          visibility: true
        },
        tpInsurerName: {
          input: "",
          visibility: false
        },
        ncb: {
          input: "",
          visibility: true
        }
      },
      previousPolicyTypes: [],
      previousInsurerName: [],
      previousPolicyExpired: "false",
      regDateDiffFromToday: ""
    };
  },
  mounted() {
    this.isUserEditing = false; // Ensure the flag is reset when the component is mounted
   
    if(this.view==='claim'){
      this.oddateError="";
    }
    this.quoteCategory=this.$store.state.quoteCategory;
    if(sessionStorage.getItem("userData")){
      const parsedData=JSON.parse(sessionStorage.getItem("userData"));
      if (parsedData.OdDate!=="") {
        this.odDate=parsedData.OdDate;
        this.tpDate=parsedData.TpDate;
        this.selectedDate=parsedData.RegDate;
        if (this.selectedDate) {
          const selectedYear = new Date(this.selectedDate).getFullYear();
        this.yearOptions = Array.from({ length: 15 }, (_, i) => selectedYear - i);
        this.selectedYear=selectedYear;
      }
        // this.isChecked=parsedData.previous_year_claim ? true : false;
        // this.percentOptions=parsedData.percentOptions;
        // this.handleDateChange();
      }
    }
    this.motorProductType = this.$store.state.motorProductType;
    this.newItem=this.data
    if (sessionStorage.getItem("userData")) {
      this.userData = JSON.parse(sessionStorage.getItem("userData"));
      this.setBHSeriesDate();
    }
    // Map Previous Insurer Name
    this.policyInfo.prevInsurerName.input =  this.sessionUserData?.previousPolicyInsurer?.toLowerCase() || "";
    // Initialize searchData with the selected value if available
    this.initializeSearchData();
    this.registrationDate = this.sessionUserData.RegDate;
    this.previousPolicyTypes = this.motorProductType=='4W-Pvt' ? this.$store.state.configData.PREVIOUS_POLICY_TYPE?.PRPOLTYP : this.$store.state.configData.PREVIOUS_POLICY_TYPE?.PRPOLTYP2;
    
    this.previousInsurerName = this.$store.state.configData.PREVIOUS_INSURER_LIST?.sort((a, b) => {
      return a.manufacturer_name.localeCompare(b.manufacturer_name);
    });
    
    this.previousPolicyExpired = this.userData && this.userData["previousPolicyExpired"] || 'false';
    if(this.userData["prevPolicyType"]){
      let policyTypes = this.motorProductType ==='4W-Pvt' ? this.$store.state.configData.PREVIOUS_POLICY_TYPE?.PRPOLTYP : this.$store.state.configData.PREVIOUS_POLICY_TYPE?.PRPOLTYP2;
      this.policyInfo.prevPolicyType.input = policyTypes.find(insurer => insurer.VALUE == this.userData["prevPolicyType"])?.NAME;
    }
    if(this.userData["prevInsurerName"]){
      let policyInsurers = this.$store.state.configData.PREVIOUS_INSURER_LIST;
      this.policyInfo.prevInsurerName.input = policyInsurers.find(insurer => insurer.manufacturer_id == this.userData["prevInsurerName"])?.manufacturer_name;
    }
    if(this.userData["tpInsurerName"]){
      let policyInsurers = this.$store.state.configData.PREVIOUS_INSURER_LIST;
      this.policyInfo.tpInsurerName.input = policyInsurers.find(insurer => insurer.manufacturer_id == this.userData["tpInsurerName"])?.manufacturer_name;
    }
    // this.policyInfo.prevInsurerName.input = this.userData && this.userData["prevInsurerName"] || "";
    // this.policyInfo.tpInsurerName.input = this.userData && this.userData["tpInsurerName"] || "";
    this.setMaxTpExpiry();
    const parsedData=JSON.parse(sessionStorage.getItem("userData"));
    if(parsedData?.previousPolicyInsurer){
      let allInsurer = this.$store.state.configData?.PREVIOUS_INSURER_LIST;
      this.policyInfo.prevInsurerName.input = allInsurer.find(insurer => insurer.manufacturer_id == parsedData?.previousPolicyInsurer)?.manufacturer_name;
    }
    this.handleNcbVisibility(this.formatDate(this.odDate));
  },
  updated() {
    this.newItem=this.data
    this.registrationDate = this.sessionUserData.RegDate;
    // Don't reinitialize search data if the user is actively editing
    this.applicablePercentage = sessionStorage.getItem("userData") ? JSON.parse(sessionStorage.getItem("userData"))?.setNCBbasedOnRegDate : "";
    // this.policyInfo.prevInsurerName.input = sessionStorage.getItem("userData") && JSON.parse(sessionStorage.getItem("userData"))?.previousPolicyInsurer || "";
  },
  
  methods: {
    initializeSearchData() {
      // Only initialize if the user is not actively editing
      if (!this.isUserEditing) {
        // Set initial search data based on the selected item
        if (this.selectedItemvalue) {
          if (this.displayStepData === 'carMake' && this.selectedItemvalue.makeDescription) {
            this.searchData = this.selectedItemvalue.makeDescription;
          } else if (this.displayStepData === 'model' && this.selectedItemvalue.modelDesc) {
            this.searchData = this.selectedItemvalue.modelDesc;
          } else if (this.displayStepData === 'variant' && this.selectedItemvalue.variantDesc) {
            this.searchData = this.selectedItemvalue.variantDesc;
          } else if (this.displayStepData === 'fuelType' && typeof this.selectedItemvalue === 'string') {
            this.searchData = (this.selectedItemvalue).toUpperCase();
          } else if (typeof this.selectedItemvalue === 'string') {
            this.searchData = this.selectedItemvalue;
          }
        }
      }
    },
    previousPolicyExpiredHandler(){
      let userData = JSON.parse(sessionStorage.getItem("userData"));
      this.userData = userData;
      let dateBefore91Days = new Date(new Date().setDate(new Date().getDate() - 91)).toISOString().split('T')[0];
      this.selectedDate = userData.RegDate;
      let ncb = [0, 20, 25, 35, 45, 50][Math.min(5, Math.floor((new Date() - new Date(userData.RegDate)) / (1000 * 60 * 60 * 24 * 365)))];

      if(this.previousPolicyExpired == 'true'){
        this.policyInfo.prevPolicyType.input = "";
        this.policyInfo.prevInsurerName.input = "";
        this.policyInfo.tpInsurerName.input = "";
        this.userData["OdDate"]=dateBefore91Days;
        this.userData["TpDate"]=dateBefore91Days;
        this.userData["setNCBbasedOnRegDate"] = `${ncb}%`;
        sessionStorage.setItem("userData", JSON.stringify(this.userData));

        const parsedData=JSON.parse(sessionStorage.getItem("userData"));
        if(parsedData?.previousPolicyInsurer){
          let allInsurer = this.$store.state.configData?.PREVIOUS_INSURER_LIST;
          this.policyInfo.prevInsurerName.input = allInsurer.find(insurer => insurer.manufacturer_id == parsedData?.previousPolicyInsurer)?.manufacturer_name;
        }
      }
    },
    onPaste(event) {
      event.preventDefault();

      const input = event.target;
      const clipboardText = (event.clipboardData || window.clipboardData).getData("text");
      const cleanText = clipboardText.replace(/\D/g, ""); // remove non-digits

      const { selectionStart, selectionEnd, value } = input;
      const newValue = (value.slice(0, selectionStart) + cleanText + value.slice(selectionEnd)).slice(0, 10);

      input.value = newValue;
      input.dispatchEvent(new Event('input')); // ensure v-model updates
    },

    limitYear(event) {
      let userData = JSON.parse(sessionStorage.getItem("userData"));
      // Get the input value
      const value = event.target.value;
      let currentDate = new Date(userData.RegDate);
      // If no value yet, clear error
      if (!value) {
        this.tpDateError = '';
        return;
      }
      
      const parts = value.split('-');
      if (!userData.RegDate) {
        return null;
      }

      
      if (isNaN(currentDate.getTime())) {
        return null;
      }

      let maxYear = "";
      if(this.motorProductType ==='4W-Pvt'){
        maxYear = currentDate.getFullYear() + 3;
      }else if(this.motorProductType ==='2W-Pvt'){
        maxYear = currentDate.getFullYear() + 5;
      }
      
      // Quick validation for year only (as user is typing)
      if (parts.length >= 1 && parts[0].length === 4) {
        const inputYear = parseInt(parts[0], 10);
        
        // Prevent invalid year > 9999
        if (inputYear > 9999) {
          parts[0] = parts[0].slice(0, 4);
          this.tpDate = parts.join('-');
        }
        
        // Check year exceeding limit
        if (inputYear > maxYear) {
          this.tpDateError = `Date cannot be more than ${this.motorProductType ==='2W-Pvt' ? 5 : 3} years from Reg Date.`;
          return;
        }
      }
      
      // Full date validation if we have all parts
      if (parts.length === 3 && parts[0].length === 4 && parts[1].length === 2 && parts[2].length === 2) {
        const maxDate = new Date(this.setMaxTpExpiry());
        const selectedDate = new Date(value);
        
        if (selectedDate > maxDate) {
          this.tpDateError = `Date cannot be more than ${this.motorProductType ==='2W-Pvt' ? 5 : 3} years from Reg Date.`;
        } else {
          this.tpDateError = '';
        }
      }
    },
    ncbPersentHandler(evt){
      let value = evt.target.value;
      let userData = JSON.parse(sessionStorage.getItem("userData"));
      userData["applicablePercentage"] = value;
      this.applicablePercentage = value;
      userData["setNCBbasedOnRegDate"] = value;
      sessionStorage.setItem("userData", JSON.stringify(userData));
      console.log("NCB Percent: ", value)
    },
    toggleFunction(){
      let ncbPercent = JSON.parse(sessionStorage.getItem("userData"))?.setNCBbasedOnRegDate;
      if(this.isChecked){
        this.applicablePercentage = '0%'
      }else{
        this.applicablePercentage = sessionStorage.getItem("userData") ? ncbPercent : "";
      }
    },
    checkBHSeries() {
      const fullCurrentYear = new Date().getFullYear();
      // const bhSeriesPattern = /^(\d{2})BH(\d{4})([A-Z]{2})$/;
      const bhSeriesPattern = /^(\d{2})([A-Z]{2})(\d{4})([A-Z]{1,2})$/;
      if(this.userData.vehicleNumber){
        const match = this.userData.vehicleNumber.match(bhSeriesPattern);
        if (!match) {
          return { valid: false, regYear: null };
        }
        const regYearLastTwo = parseInt(match[1], 10);
        const regYearFull = 2000 + regYearLastTwo;
        if (regYearFull < 2021 || regYearFull > fullCurrentYear) {
          return { valid: false, regYear: regYearFull };
        }
        return { valid: true, regYear: regYearFull };
      }
    },
    setBHSeriesDate(){
      if(this.userData.vehicleNumber){
        this.userData = JSON.parse(sessionStorage.getItem("userData"));
        
        if(this.checkBHSeries().valid){
          this.isBHSeries = true;
          this.bhMinDate = `${this.checkBHSeries().regYear}-01-01`;
          this.userData["RegDate"]= this.userData.RegDate ? this.userData.RegDate :`${this.checkBHSeries().regYear}-01-01`;
          this.userData["MfgYear"]=this.checkBHSeries().regYear;
          sessionStorage.setItem("userData",JSON.stringify(this.userData));
          this.selectedDate = this.userData["RegDate"];
          this.selectedYear=this.userData["MfgYear"];
          this.setNcbPercent();
        }else{
          this.isBHSeries = false;
          this.setNcbPercent();
          return;
        }
      }
    },
    setNcbPercent(){
      let ncb = [0, 20, 25, 35, 45, 50][Math.min(5, Math.floor((new Date() - new Date(this.userData["RegDate"])) / (1000 * 60 * 60 * 24 * 365)))];
      this.userData["setNCBbasedOnRegDate"] = `${ncb}%`
      this.applicablePercentage = this.userData?.setNCBbasedOnRegDate;
      sessionStorage.setItem("userData", JSON.stringify(this.userData));
    },
    isDateMoreThan90Days(odDate) {
      const date = new Date(odDate);
      const currentDate = new Date();
      const differenceInMilliseconds = currentDate - date;
      const differenceInDays = differenceInMilliseconds / (1000 * 60 * 60 * 24);
      return differenceInDays > 90;
  },
    clearSearchTerm(){
      this.searchData = "";
      this.isUserEditing = false; // Reset the editing flag
      this.focusTheInput();
      this.filteredResultData.length = 0;
    },
    showExample(){
      if (this.displayStepData === 'rtoCode'){
        const make = this.displayedData[0]?.toUpperCase() || '';
        const city = this.sessionUserData?.city ? ` (${this.sessionUserData.city.toUpperCase()})` : '';
        return make + city;
      }
      else if (this.displayStepData === 'carMake') {
        return this.displayedData[0]?.makeDescription.toUpperCase();
      }
      else if(this.displayStepData=='model'){
        return this.displayedData[0]?.modelDesc.toUpperCase();
      }
      else if(this.displayStepData=='variant'){
        return this.displayedData[0]?.variantDesc.toUpperCase();
      }
      else if(this.displayStepData=='fuelType'){
        return this.displayedData[0]?.toUpperCase();
      }
      else{
        return this.displayedData[0]?.toUpperCase();
      }
    },
    validateOdDate(event) {
      const inputDate = moment(event.target.value, "DD-MM-YYYY").toDate();
      inputDate.setHours(0, 0, 0, 0);

      const maxDate = new Date(this.maxOdTpDate());
      maxDate.setHours(0, 0, 0, 0);
      if (inputDate > maxDate) {
        event.target.value = this.maxOdTpDate();
        this.odDate = "";
        this.oddateError = "Expiry Date can not be greater than 60 days in future"
      } else {
        this.oddateError = ""
      }
    },
    handleNcb(event) {
      this.handleNcbVisibility(event.target.value);
    },
    formatDate(date){
      return new Date(date).toLocaleDateString("en-GB").replace(/\//g, "-");
    },
    handleNcbVisibility(odDate) {
      const updatedValue = this.previousPolicyTypes.find(
        policy => policy.NAME === this.policyInfo.prevPolicyType.input
      )?.VALUE;

      if (updatedValue === 'StandaloneTP(1)') {
        this.policyInfo.ncb.visibility = false;
        this.applicablePercentage = "0%";
        return;
      }

      if(odDate){
        const inputDate = moment(odDate, "DD-MM-YYYY").toDate();
        inputDate.setHours(0, 0, 0, 0);
        const currentDate = new Date();
        currentDate.setHours(0, 0, 0, 0);
        const diffInMs = currentDate - inputDate;
        const diffInDays = diffInMs / (1000 * 60 * 60 * 24);
        
        this.policyInfo.ncb.visibility = !(diffInDays && diffInDays > 90);
        if(!this.policyInfo?.ncb?.visibility){
          this.applicablePercentage = "0%";
        }
      }
    },
    calculateMaxDate() {
                    // Calculate today's date
                    let today = new Date();
                    let maxDate = new Date(today);
                    if(this.quoteCategory=="Roll-Over"){
                      maxDate.setMonth(maxDate.getMonth() - 10);
                      let yyyy = maxDate.getFullYear();
                      let mm = String(maxDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
                      let dd = String(maxDate.getDate()).padStart(2, '0'); 
                     return `${yyyy}-${mm}-${dd}`;
                    }
                    if(this.quoteCategory=="New"){
        maxDate.setDate(maxDate.getDate() + 30);
        let yyyy = maxDate.getFullYear();
        let mm = String(maxDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        let dd = String(maxDate.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
      }
           
                },
                
      calculateMinDate(){
        if(this.quoteCategory=="New"){
        let today = new Date();
        let yyyy = today.getFullYear();
        let mm = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        let dd = String(today.getDate()).padStart(2, '0');
        console.log("--",`${yyyy}-${mm}-${dd}`)
        return `${yyyy}-${mm}-${dd}`;
      }
      else{
        return `${1950}-${11}-${11}`;
      }
      },
      handleDateChange(event) {
        const inputDate = moment(event.target.value, "DD-MM-YYYY").toDate();
        inputDate.setHours(0, 0, 0, 0);

        const maxDate = new Date(this.calculateMaxDate());
        maxDate.setHours(0, 0, 0, 0);

        const minDate = new Date(this.calculateMinDate());
        minDate.setHours(0, 0, 0, 0);
        this.odDate = "";
        console.log("ODDATE", this.odDate)
        if(this.quoteCategory=="New"){
          if(inputDate<minDate || inputDate > maxDate){
            event.target.value = ""; 
            this.selectedDate='';
            this.dateError="Registration Date can be between current date and upto 30 days in future"
          }
          else {
            this.dateError="";
            // this.selectedDate = event.target.value; 
            if (this.selectedDate) {
              const selectedYear = new Date(this.selectedDate).getFullYear();
              this.yearOptions = Array.from({ length: 5 }, (_, i) => selectedYear - i);
              this.selectedYear = selectedYear; 
              this.userData = JSON.parse(sessionStorage.getItem("userData"));
              this.userData["RegDate"]=this.selectedDate;
              // this.userData["MfgYear"]=this.selectedYear;
              sessionStorage.setItem("userData",JSON.stringify(this.userData));              
            }
          }
        }
        else{
          if (inputDate > maxDate || inputDate<minDate) {
            event.target.value = ""; 
            this.selectedDate='';
            // this.yearOptions = "";
            if(this.quoteCategory=="Roll-Over"){
              this.dateError="Registration date cannot be less than 10 months in the past"
            }
          } 
          else {
            this.dateError="";
            // this.selectedDate = event.target.value; 
            if (this.selectedDate) {
              const selectedYear = new Date(this.selectedDate).getFullYear();
              this.yearOptions = Array.from({ length: 15 }, (_, i) => selectedYear - i);
              this.selectedYear = selectedYear; 
              this.userData = JSON.parse(sessionStorage.getItem("userData"));
              this.userData["RegDate"]=this.selectedDate;
              // this.userData["MfgYear"]=this.selectedYear;
              // this.regDateDiffFromTodayIndex = Math.round((new Date() - new Date("2023-09-28")) / (1000 * 60 * 60 * 24 * 365));
              let ncb = [0, 20, 25, 35, 45, 50][Math.min(5, Math.floor((new Date() - new Date(this.selectedDate)) / (1000 * 60 * 60 * 24 * 365)))];
              this.userData["setNCBbasedOnRegDate"] = `${ncb}%`

              sessionStorage.setItem("userData",JSON.stringify(this.userData));
            }
          }
        }
        if(this.dateDifference(this.selectedDate) > 25 && this.quoteCategory=="Roll-Over"){
          this.selectedDate = "";
          this.dateError = "Registration date cannot be more than 25 years in the past. "
          this.selectedYear = ""
        }else{
          this.dateError = ""
        }
      },

    dateDifference(date) {
      const givenDate = new Date(date);
      const today = new Date();
      let years = today.getFullYear() - givenDate.getFullYear();
      const hasNotHadBirthdayThisYear =
        today.getMonth() < givenDate.getMonth() ||
        (today.getMonth() === givenDate.getMonth() && today.getDate() < givenDate.getDate());

      if (hasNotHadBirthdayThisYear) {
        years--;
      }

      return years;
    },       
    // handleDateChange() {
    //   if (this.selectedDate) {
    //     const selectedYear = new Date(this.selectedDate).getFullYear();
    //     this.yearOptions = [selectedYear, selectedYear - 1];
    //     this.selectedYear = selectedYear; // Default to the selected year
    //     this.userData = JSON.parse(sessionStorage.getItem("userData"));
    //     this.userData["RegDate"]=this.selectedDate;
    //     // this.userData["MfgYear"]=this.selectedYear;
    //   sessionStorage.setItem("userData",JSON.stringify(this.userData));
    //   } else {
    //     this.yearOptions = [];
    //     this.selectedYear = '';
    //   }
    // },
    isNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      var inputValue = evt.target.value;
      if ((inputValue === "0" && inputValue.length > 0) || (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    getFieldValidation(name,event){
    
      if(name=="mobile"){
        const regex = /^[6789]\d{9}$/;
        if(regex.test(this.newBikeUser.mobile)){
          this.error["mobile"]=""
        }else{ 
          this.error["mobile"] = "Please enter a valid mobile number";
        }
      }else if (name=="email") {
        const value = event.target.value;
        console.log("EMail Validation: ", value, name)
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (emailPattern.test(value)) {
          this.error["email"]=""
        }else{
          this.error["email"] = "Please enter a valid Email";
        }
      }
      // else if (name=="pinCode") {
      //     if(this.newBikeUser.pincode && event.target.value.length==6){
      //     // this.error["pinCode"] = "";
      //     // getPincode(this.userData.pinCode);
      //     this.getPincode(this.newBikeUser.pincode);
      //     }
      //   else {
      //     this.incorrectData = true;
      //     this.error["pinCode"] = "Please enter a valid Pincode";
      //   }
      // }
    },
    checkformData(){
      console.log("inside checkformData")
       if (this.error["mobile"] == "" && this.error["email"] == "" ){ 
         this.incorrectData = false;
        }
        else {
          this.incorrectData = true;
        }
   },
   getPincode(pincode){
    this.incorrectData = true;  
    let headers={};
          let reqData=[pincode];
          this.backendApi("getPincodeInfo", reqData, headers, "get")
        .then((response) => {
          if(response.data.errors.length >0) {
            this.incorrectData = true;  
            this.error["pinCode"] = "Please enter a valid Pincode";
          } else if(response && response.data) {
            this.incorrectData = false;
            this.error["pinCode"] = '';
          }
        })
        .catch((error) => {
          this.incorrectData = true;  
          console.log('error msg block dp', error);
          const msg = "Service is Unavailable, Please try again later.";
          this.$router.push({ path: '/error-page', query: { backUrl:'New-Journey', msg: msg } });
        });
   },
 
    //add session Data
    addOdTpDate($event){
      $event.preventDefault();
      if(!this.policyInfo.ncb.visibility){
        this.applicablePercentage = "0%";
      }     
      this.userData= JSON.parse(sessionStorage.getItem("userData"));
      this.userData["OdDate"]=this.odDate;
      this.userData["TpDate"]=this.tpDate;
      this.userData["previous_year_claim"]=this.isChecked;
      this.userData["applicablePercentage"]=this.applicablePercentage;
        let isDateMoreThan90Days=this.isDateMoreThan90Days(this.odDate)
      if(isDateMoreThan90Days){
      let percentOptions90days=[];
      // percentOptions90days.push(this.percentOptions[0]);
      this.userData["percentOptions"] = this.percentOptions;
      }
      else{
      this.userData["percentOptions"] = this.percentOptions
      }
      this.userData["prevPolicyType"] = this.previousPolicyTypes.find(policy => policy.NAME == this.policyInfo.prevPolicyType.input)?.VALUE;
      this.userData["prevInsurerName"] = this.previousPolicyExpired == 'true' ? "" : this.previousInsurerName.find(name => name.manufacturer_name ==this.policyInfo.prevInsurerName.input)?.manufacturer_id;
      this.userData["tpInsurerName"] = this.previousPolicyExpired == 'true' ? "" : this.previousInsurerName.find(name => name.manufacturer_name == this.policyInfo.tpInsurerName.input)?.manufacturer_id;
      this.userData["previousPolicyExpired"] = this.previousPolicyExpired;
      
      sessionStorage.setItem("userData",JSON.stringify(this.userData));
      const data=JSON.parse(sessionStorage.getItem("userData"));
      const regdate=data.RegDate;
      const odddate = new Date(this.odDate);
      const selectedDate = new Date(regdate);

      const oneYearAgo = new Date(odddate);
      oneYearAgo.setFullYear(odddate.getFullYear() - 1);
      console.log("-----",selectedDate,oneYearAgo)

      this.setPinCode();
      sessionStorage.removeItem("motorCovers");
      sessionStorage.removeItem("motor_covers");
      this.$router.push("/policy-quote");
      return true;
    },
    setPinCode(){
      let allRto = JSON.parse(sessionStorage.getItem('all-rto'));
      let zipCodeObj = allRto && allRto.filter(rto => rto.state===this.userData.state && rto.city===this.userData.city && rto.rtoCode===this.userData.rtoCode);        
      if(zipCodeObj && zipCodeObj.length > 0 && zipCodeObj[0].zipCode){
        this.userData["pinCode"]=zipCodeObj[0].zipCode;
        sessionStorage.setItem('userData', JSON.stringify(this.userData));
      }
    },
    ViewQuoteNewVehicle($event){
      $event.preventDefault();
      this.userData= JSON.parse(sessionStorage.getItem("userData"));
      this.userData["mobileNumber"]=this.newBikeUser.mobile;
      this.userData["email"]=this.newBikeUser.email;
      this.userData["applicablePercentage"]=0;
      this.userData["OdDate"]="";
      sessionStorage.setItem("userData",JSON.stringify(this.userData));
      this.setPinCode();
      sessionStorage.removeItem("motorCovers");
      sessionStorage.removeItem("motor_covers");
      this.$router.push("/policy-quote");
    },
    deepEqual(obj1, obj2) {
      if (obj1 === obj2) return true; 
      if (obj1 == null || obj2 == null) return false;
      if (typeof obj1 !== 'object' || typeof obj2 !== 'object') return false;
      
      const keys1 = Object.keys(obj1);
      const keys2 = Object.keys(obj2);
      
      if (keys1.length !== keys2.length) return false; 
      
      for (let key of keys1) {
        if (!keys2.includes(key) || !this.deepEqual(obj1[key], obj2[key])) return false;
      }
      
      return true;
    },


    getNewData(item, selectedDate='', selectedYear='') {
      this.isUserEditing = false; // Reset the editing flag after selection
      this.selectedYear = selectedYear;
      this.userData = JSON.parse(sessionStorage.getItem("userData"));
      this.userData["MfgYear"] = this.selectedYear;
      sessionStorage.setItem("userData", JSON.stringify(this.userData));
      this.minOdDate();
      // Update searchData to match the selected item
      if (typeof item === 'object') {
        if (this.displayStepData === 'carMake' && item.makeDescription) {
          this.searchData = item.makeDescription;
        } else if (this.displayStepData === 'model' && item.modelDesc) {
          this.searchData = item.modelDesc;
        } else if (this.displayStepData === 'variant' && item.variantDesc) {
          this.searchData = item.variantDesc;
        }
      } else if (typeof item === 'string') {
        this.searchData = item;
      }
      
      // Check if the selected item is different from the previous selection
      const previousValue = this.userData[this.displayStepData];
      const isSameSelection = this.isSameSelection(previousValue, item);
      
      // Only emit with the flag indicating if selection has changed
      this.$emit('item-clicked', {
        "key": this.displayStepData, 
        "value": item, 
        "selectedDate": selectedDate, 
        "selectedYear": selectedYear,
        "selectionChanged": true
      });
    },
    
    isSameSelection(previousValue, currentValue) {
      if (!previousValue || !currentValue) return false;
      
      if (typeof currentValue === 'object' && typeof previousValue === 'object') {
        return this.deepEqual(previousValue, currentValue);
      }
      
      return previousValue === currentValue;
    },
    
    filterData() {
      // Set the editing flag when the user starts typing
      this.isUserEditing = true;
      
      if (this.searchData.length === 0) {
        this.filteredResultData = [];
        this.noSearchMatch = false;
        return;
      }
      else {
        if (this.displayStepData == "carMake") {
          const searchTerm = this.searchData.toLowerCase();
          this.filteredResultData = this.newItem.filter(item =>
            item.makeDescription.toLowerCase().startsWith(searchTerm.toLowerCase()))
        }
        else if (this.displayStepData == "model") {
          const searchTerm = this.searchData.toLowerCase();
          this.filteredResultData = this.newItem.filter(item =>
            item.modelDesc.toLowerCase().startsWith(searchTerm.toLowerCase()))
        }
        else if (this.displayStepData == "variant") {
          const searchTerm = this.searchData.toLowerCase();
          this.filteredResultData = this.newItem.filter(item =>
            item.variantDesc.toLowerCase().startsWith(searchTerm.toLowerCase()))
        }
        else if (this.displayStepData == "fuelType") {
          const searchTerm = this.searchData.toLowerCase();
          this.filteredResultData = this.newItem.filter(item =>
            typeof item === 'string' ? item.toLowerCase().startsWith(searchTerm.toLowerCase()) : false)
        }
        else {
         
          const searchTerm = this.searchData.toLowerCase();
          this.filteredResultData = this.newItem.filter(item =>
            item.toLowerCase().startsWith(searchTerm.toLowerCase()))
        }

        if(this.filteredResultData.length > 0){
          this.noSearchMatch = false;
        }else{
          this.noSearchMatch = true;
        }
      }
      console.log("this.displayedData",this.displayedData);
    },

    filterUniqueValues(property) {
      const uniqueValues = new Set();
      this.resultData.forEach(item => {
        uniqueValues.add(item[property]);
      });
      return Array.from(uniqueValues);
    },
    setMaxTpExpiry() {
      if (!this.registrationDate) {
        return null;
      }

      let currentDate = this.registrationDate && new Date(this.registrationDate);
      
      // if (isNaN(currentDate.getTime())) {
      //   return null;
      // }

      let maxYear = "";
      if (this.motorProductType === '4W-Pvt') {
        maxYear = currentDate.getFullYear() + 3;
      } else if (this.motorProductType === '2W-Pvt') {
        maxYear = currentDate.getFullYear() + 5;
      }

      let month = String(currentDate.getMonth() + 1).padStart(2, '0'); // 0-indexed
      let day = String(currentDate.getDate()).padStart(2, '0');

      let maxTpDate = `${maxYear}-${month}-${day}`;
      console.log("maxTpDate", maxTpDate);
      return maxTpDate;
    },
    isComprehensivePolicy() {
      return this.policyInfo?.prevPolicyType?.input?.toLowerCase() === 'comprehensive policy';
    },
    prePolicyTypeHandler(evt) {
      this.policyInfo.tpInsurerName.visibility = (this.showTpSection && !this.isComprehensivePolicy()) ? true : false;
      this.handleNcbVisibility(this.formatDate(this.odDate));
    },
    maxOdTpDate() {
      const today = new Date();
      const maxDate = new Date(today);
      maxDate.setDate(today.getDate() + 90);
      return maxDate.toISOString().split('T')[0]; // Formats the date as YYYY-MM-DD
    },
    minOdDate() {
      let today;
      // this.odDate = "";
      let regDateUpdated = sessionStorage.getItem("userData") && JSON.parse(sessionStorage.getItem("userData"))?.RegDate;
      let regDate = regDateUpdated;
      // Check if selectedDate is valid
      if (regDate) {
        today = new Date(regDate);
      } else {
        today = new Date(); // fallback to current date
      }
      const minDate = new Date(today);
      minDate.setDate(today.getDate() - 60);
      return minDate.toISOString().split('T')[0];
    },
  },
  watch: {
    odDate(newVal) {
      const inputDate = new Date(newVal);
      const maxDate = new Date(this.maxOdTpDate());
      
      if (inputDate > maxDate) {
        this.oddateError = "Expiry Date can not be greater than 60 days in future";
      } else {
        this.oddateError = "";
      }
    },
    resultData: {
      immediate: true,
      handler(newVal) {
        this.filteredResultData = newVal;
      },
    },
    data: {
      handler() {
        // Only reinitialize if not actively editing
        if (!this.isUserEditing) {
          this.initializeSearchData();
        }
      }
    },
    displayStepData: {
      immediate: true,
      handler() {
        this.isUserEditing = false; // Reset editing flag when step changes
        this.filterData();
      },
    },
    selectedItemvalue: {
      immediate: true,
      handler() {
        this.isUserEditing = false; // Reset editing flag when selected item changes
        this.initializeSearchData();
      }
    },
    /** Keep TP insurer validation aligned with props: older reg years hide TP fields (showTpSection false)
     * but tpInsurerName.visibility was only set in prePolicyTypeHandler — stale true left View Quotes disabled. */
    showTpSection: {
      immediate: true,
      handler() {
        this.policyInfo.tpInsurerName.visibility =
          this.showTpSection && !this.isComprehensivePolicy();
        if (!this.showTpSection) {
          this.tpDateError = '';
        }
      },
    },
  },
  computed: {
    displayedData() {
      // Return the sliced data based on showAllItems
      if (this.showAllItems) {
        return this.data;
      } else {
        return this.data.slice(0, 10);
      }
    },
    minDate() {
      if(this.isBHSeries){
        return this.bhMinDate;
      }
      let today = new Date();

      if(this.quoteCategory=="New"){
        let yyyy = today.getFullYear();
        let mm = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        let dd = String(today.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
      }
       if (this.quoteCategory === "Roll-Over") {
        const minDate = new Date(today);
        minDate.setFullYear(today.getFullYear() - 25);
        let yyyy = minDate.getFullYear();
        let mm = String(minDate.getMonth() + 1).padStart(2, '0');
        let dd = String(minDate.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
      }

      // Default fallback
      return `1950-10-11`;
    
},
    maxDate() {
      // Calculate today's date
      let today = new Date();
      // Calculate max date as today + 3 days
      let maxDate = new Date(today);
      if(this.isBHSeries){
        return `${this.userData["MfgYear"]}-12-31`;
      }
      if(this.quoteCategory=="Roll-Over"){
        maxDate.setMonth(maxDate.getMonth() - 10);
        let yyyy = maxDate.getFullYear();
        let mm = String(maxDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        let dd = String(maxDate.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
      }
      if(this.quoteCategory=="New"){
        maxDate.setDate(maxDate.getDate() + 30);
        let yyyy = maxDate.getFullYear();
        let mm = String(maxDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        let dd = String(maxDate.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
      }
      
    },
    currentYear() {
      return new Date().getFullYear();
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../assets/scss/components/select-card.scss";
@import "../../assets/scss/components/filters.scss";
@import "../../assets/scss/components/select-RTO.scss";
.highlightColor {
  cursor: not-allowed !important;
 background-color: $main-bg; /* Example */
  p{
    color: rgb(255, 255, 255); /* Example */ 
    opacity: 1;
  }
  img{
    filter: invert(6);
  }
  &:hover{
    p{
      color: rgb(255, 255, 255);
    }
  }
}
.prev_policy_exp{
  margin-bottom: 12px !important;
  input[type="radio"]{
    transform: scale(1.4);
  }
  .form-check-label{
    font-size: 13px !important;
  }
}
.form-switch{
  padding-left: 0 !important;
}
.error-text {
  color: $error-txt !important;
  font-family: $fontFamily;
  font-size: 12px;
}

.dark {
    .commonicon{
    filter: invert(1);
  }

}
</style>
